/* @flow */

const navegarEntreElementos = (direcao: 1 | -1) => (selector: string) => (event: KeyboardEvent) => {
    const { activeElement } = document;
    if (!activeElement) {
        return;
    }

    const itens = Array.from(document.querySelectorAll(selector));
    const index = itens.indexOf(activeElement);
    if (itens[index + direcao]) {
        event.preventDefault();
        activeElement.blur();
        itens[index + direcao].focus();
    }
};

export const navegarProximoElemento = navegarEntreElementos(1);
export const navegarElementoAnterior = navegarEntreElementos(-1);
